<template>
  <section class="evento-lux">
    <img src="@/assets/elemento2.png" class="petalo-flotante petalo-izq-1" alt="" />
    <img src="@/assets/elemento2.png" class="petalo-flotante petalo-der-1" alt="" />

    <div ref="seccionBloque2" class="bloque-evento" aria-label="Recepción">
      <img class="icono-lazo" src="@/assets/cek.png" alt="Icono Recepción" />
      
      <p class="hora-top">6:00 P.M.</p>
      <h3 class="titulo-editorial"> RECEPCIÓN</h3><br>
      <p class="lugar-luxury">Ara Eventos
 </p>

      <!-- Imagen Circular con Sombra y Animación
      <div class="imagen-lugar-wrapper shadow-luxury-img">
        <img src="@/assets/ChatGPT Image 23 sept 2026, 05_36_12 p.m..png" class="imagen-lugar" alt="Recepción" />
      </div>
 -->
      <p class="direccion-editorial">
   Ecuador 736, Anzalduas<br />   Reynosa, Tamaulipas.<br />  
      </p>

      <a
        ref="btn2"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/JYd5atP7vwJYKRASA"
        target="_blank"
        rel="noopener"
      >
        ¿Como llegar?
        <span class="sheen"></span>
      </a>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const seccionBloque2 = ref(null)
    const btn2 = ref(null)

    let ctx2; 
    let animPetalos; 

    const crearAnimacionServidor = (bloqueEl, btnEl) => {
      if (!bloqueEl || !btnEl) return

      const $ = gsap.utils.selector(bloqueEl)
      
      const lazo = $('.icono-lazo')
      const hora = $('.hora-top')
      const titulo = $('.titulo-editorial')
      const lugar = $('.lugar-luxury')
      const imgLugar = $('.imagen-lugar-wrapper')
      const dir = $('.direccion-editorial')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bloqueEl,
          start: 'top 80%', 
          toggleActions: 'play none none reverse' 
        },
        defaults: { ease: 'power3.out', duration: 0.6 }
      })

      tl.fromTo(bloqueEl, { opacity: 0, y: 35 }, { opacity: 1, y: 0, duration: 0.7 })
        .fromTo(lazo, { opacity: 0, scale: 0.6, y: -20 }, { opacity: 1, scale: 1, y: 0 }, '-=0.45')
        .fromTo(hora, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(titulo, { opacity: 0, letterSpacing: '0.02em', y: 15 }, { opacity: 1, letterSpacing: 'initial', y: 0 }, '-=0.4')
        .fromTo(lugar, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        
        .fromTo(imgLugar, 
          { opacity: 0, scale: 0.7, rotate: -8, y: 20 }, 
          { opacity: 1, scale: 1, rotate: 0, y: 0, duration: 0.8, ease: 'back.out(1.4)' }, 
          '-=0.3'
        )

        .fromTo(dir, { opacity: 0, y: 15 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(btnEl, { opacity: 0, y: 15, scale: 0.93 }, { opacity: 1, y: 0, scale: 1, duration: 0.4 }, '-=0.3')

      ScrollTrigger.create({
        trigger: bloqueEl,
        start: 'top 80%',
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 1.1, ease: 'power2.inOut', delay: 0.9 }
          )
        }
      })
    }

    onMounted(async () => {
      await nextTick()

      if (seccionBloque2.value) {
        ctx2 = gsap.context(() => {
          crearAnimacionServidor(seccionBloque2.value, btn2.value)
        }, seccionBloque2.value)
      }

      animPetalos = gsap.to('.petalo-flotante', {
        y: '+=10',
        rotation: '+=6',
        duration: 3.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        stagger: 0.35
      })
    })

    onUnmounted(() => {
      if (ctx2) ctx2.revert()
      if (animPetalos) animPetalos.kill()
    })

    return { seccionBloque2, btn2 }
  }
}
</script>

<style scoped>
/* ==================== CONFIGURACIÓN ESTILO EDITORIAL COINCIDENTE ==================== */
.evento-lux {
  position: relative;
  width: 100%;
  padding: 4vh 5vw 6vh; 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  margin-top: 0px !important; 
  align-items: center;
  margin-bottom: 60px;
  box-sizing: border-box;
  overflow: hidden;
}

/* ==================== BLOQUES CONTENEDORES CONTRAÍDOS ==================== */
.bloque-evento {
  width: min(100%, 420px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  margin-bottom: 0;
}

.icono-lazo {
  width: auto;
  height: clamp(100px, 18vh, 150px) !important;
  display: block;
  margin: 0 auto 1.5vh;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(225, 180, 185, 0.25));
}

/* ==================== IMAGEN CIRCULAR LUXURY ==================== */
.imagen-lugar-wrapper {
  width: min(55vw, 175px);
  height: min(55vw, 175px);
  border-radius: 50%;
  overflow: hidden;
  margin: 1.5vh auto 2vh;
  background: #fff;
  border: 3px solid #ffffff;
  will-change: transform, opacity;
}

.imagen-lugar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-luxury-img {
  box-shadow: 
    0 10px 30px rgba(225, 180, 185, 0.35),
    0 2px 8px rgba(0, 0, 0, 0.05);
}

/* ==================== TIPOGRAFÍAS DE ALTA GAMA ==================== */
.hora-top {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.3rem, 4.2vw, 1.55rem);
  font-weight: 800;
  color: #536559;
  margin: 0 0 0.5vh 0;
  letter-spacing: 0.05em;
}

.titulo-editorial {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: clamp(1.4rem, 6.5vw, 1.75rem);
  color: #536559;
  margin: 0 0 1vh 0;
  letter-spacing: 0.12em;
  line-height: 1.15;
}

.lugar-luxury {
  font-family: 'padres', serif;
  font-size: clamp(1.4rem, 5vw, 1.4rem);
  color: #536559;
  font-weight: 900;
  margin: 0.5vh 0 1.5vh 0;
  line-height: 1.2;
}

.direccion-editorial {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  color: #555555;
  font-size: clamp(0.9rem, 3.2vw,1rem);
  line-height: 1.5;
  margin: 0 auto 2vh;
  max-width: 85%;
  letter-spacing: 0.02em;
}

/* ==================== BOTÓN DE DISEÑO FLUSH ==================== */
.btn-editorial-rosa {
  display: inline-flex !important;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 1.2vh 6vw;
  border-radius: 14px;
 background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;

  color: #000000 !important;  background-size: cover;
  background-position: center;
  background-color: #bf953f;
  color: #0a0a0a !important;
  -webkit-text-fill-color: #0a0a0a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 900;
  font-size: clamp(0.99rem, 3.5vw, 1.2rem);
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 5;
  overflow: hidden;
}

.btn-editorial-rosa:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(222, 176, 182, 0.5);
}

.btn-editorial-rosa:active {
  transform: translateY(0);
}

.btn-editorial-rosa .sheen {
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;

  color: #000000 !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.6);
}

/* ==================== PÉTALOS ACENTUADOS A LOS COSTADOS ==================== */
.petalo-flotante {
  position: absolute;
  width: clamp(50px, 18vw, 85px);
  height: auto;
  object-fit: contain;
  pointer-events: none;
  opacity: 0.85;
  z-index: 1;
}

.petalo-izq-1 {
  top: 5%;
  left: -2vw;
  transform: rotate(-15deg);
}

.petalo-der-1 {
  top: 60%;
  right: -3vw;
  transform: rotate(20deg) scaleX(-1);
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
</style>